import {
  getAuthenticatedAxios,
  withErrorHandler,
} from './AuthenticatedAxiosProvider';
import { buildRequestUrl } from '../Config';

/**
 * The PDF is produced server side (user + activity + codeword fetches, a
 * template render, base64-inlining of every evidence photo, then an
 * HTML-to-PDF conversion), so a photo-heavy diary can legitimately take
 * longer than the shared 10s axios timeout.
 */
const EXPORT_PDF_TIMEOUT_MS = 120000;

export const GetActivityLogExportPdf = async () => {
  const url = buildRequestUrl('/api/users/lbp/activities/pdf');
  const response = await withErrorHandler(() =>
    getAuthenticatedAxios().get(url, {
      responseType: 'blob',
      timeout: EXPORT_PDF_TIMEOUT_MS,
    }),
  );

  /**
   * withErrorHandler returns undefined when it handled the failure itself
   * (401/403/5xx redirect dispatch, or a cancelled request). Surface that as
   * an error rather than destructuring undefined, so the caller's catch can
   * show its failure toast.
   */
  if (!response) {
    throw new Error('LBP activities PDF request did not complete.');
  }

  return response.data;
};
